import { Keyframes, Variants } from 'framer-motion';
import { generateColorShades, theme as oplTheme } from '../theme/theme';

export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

export const COLORS = {
  primary: '#20368A',
};

export const theme = {
  ...oplTheme,
  colors: {
    ...oplTheme.colors,
    primary: generateColorShades(COLORS.primary),
  },
};

export interface CardAnimation {
  scaleFactor: number;
  easing: Keyframes['ease'];
  duration: number;
}

// Use this to control the card animation.
export const CARD_ANIMATION: CardAnimation = {
  scaleFactor: 0.25,
  easing: 'easeInOut',
  duration: 0.2,
};

export const cardAnimationVariants: Variants = {
  enter: {
    opacity: 0,
    scale: 1 + CARD_ANIMATION.scaleFactor,
  },

  visible: {
    opacity: 1,
    scale: 1,

    transition: {
      duration: CARD_ANIMATION.duration,
      ease: CARD_ANIMATION.easing,
    },
  },
};

export const logoAnimationVariants: Variants = {
  enter: {
    opacity: 0,
  },

  visible: {
    opacity: 1,

    transition: {
      duration: 0.7,
    },
  },
};

export const DEFAULT_COLOR = {
  base: '#19027F',
  highlight: '#056DCA',
};

export const CHART_COLOR_BY_SCORE = {
  25: {
    base: '#FDBA8C',
    highlight: '#FCD9BD',
  },
  74: {
    base: '#FBCB16',
    highlight: '#FCE96A',
  },
  100: {
    base: '#84E1BC',
    highlight: '#BCF0DA',
  },
};

export enum Persona {
  Communication = 'Communication',
  Worry = 'Worry',
  Purpose = 'Purpose',
  Use = 'Use',
  Importance = 'Importance',
}

export const PERSONA_ICON_MAP = {
  [Persona.Communication]: {
    scored: 'far fa-bow-arrow',
    default: 'far fa-route',
  },
  [Persona.Worry]: {
    scored: 'far fa-clipboard-check',
    default: 'far fa-narwhal',
  },
  [Persona.Purpose]: {
    scored: 'far fa-sack-dollar',
    default: 'far fa-mug-hot',
  },
  [Persona.Use]: {
    scored: 'far fa-heart-broken',
    default: 'fas fa-shield-alt',
  },
  [Persona.Importance]: {
    scored: 'far fa-wallet',
    default: 'far fa-flower-tulip',
  },
};
